import React from 'react';
import styled from 'styled-components';
import { breakPoint } from '../styles/var';

const PictureStyles = styled.picture`
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  font-size: 0;
  display: block;
  text-align: center;
  .rounded {
    border-radius: 50%;
    overflow: hidden;
  }
  & > img {
    max-width: ${({toHeight}) => toHeight ? '' : '100%'};
    height: ${({toHeight}) => toHeight ? '100%' : 'auto'};
    vertical-align: middle;
  }
  @media (max-width: ${breakPoint.max}) {
    & > img {
      max-width: unset;
      width: 100%;
    }
  }
`;


// const AutoImgWrap = styled.div`
//   width: 100%;
//   position: relative;
//   border-radius: ${({rounded}) => rounded ? '50%' : ''};
//   overflow: hidden;
//   font-size: 0;
//   & > img {
//     max-width: 100%;
//     height: auto;
//      vertical-align: middle;
//   }
// `

// const FixedImgWrap = styled(AutoImgWrap)`
//   font-size: 0;
//   & > div {
//     height: 0;
//     padding-bottom: 100%;
//   }
//   & > img {
//     position: absolute;
//     top: 0;
//     left: 0;
//     height: 100%;
//     object-fit: ${({objectFit}) => objectFit || 'cover'};
//     object-position: center center;
//   }
// `

const Img = ({
  refs,
  alt = "",
  wrapProps,
  lgSrc,
  toHeight = false,
  ...props
}) => {
  return (
    <PictureStyles toHeight={toHeight} {...wrapProps}>
      {lgSrc && <source srcSet={lgSrc} media="(min-width: 768px)" />}
      <img ref={refs} alt={alt} {...props} />
    </PictureStyles>
  );
};

// const Img = ({refs, objectFit, auto, alt = "", rounded, wrapProps, ...props}) => {
//   if (Boolean(auto)) {
//     return (
//       <AutoImgWrap {...wrapProps} rounded={rounded}>
//         <img ref={refs} {...props} alt={alt}/>
//       </AutoImgWrap>
//     )
//   }
//   return (
//     <FixedImgWrap {...wrapProps} objectFit={objectFit} rounded={rounded}>
//       <div/>
//       <img ref={refs} {...props} alt={alt}/>
//     </FixedImgWrap>
//   )
// }

export default Img;
